import { defineComponent as o } from "vue";
import m from "./index574.js";
import r from "./index575.js";
import t from "./index576.js";
const f = o({
  name: "MsInteractiveIcons",
  components: {
    Arrow: m,
    Law: r,
    Mail: t
  }
});
export {
  f as default
};
